'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _clickedMeetingsLink = require('../../actions/MeetingsActions/clickedMeetingsLink');

var _MeetingsLinkButton = require('../components/MeetingsLinkButton');

var _MeetingsLinkButton2 = _interopRequireDefault(_MeetingsLinkButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    assignedResponder: (0, _getAssignedResponderInWidget.getAssignedResponderInWidget)(state),
    widgetData: (0, _getLatestWidgetData.getLatestWidgetData)(state)
  };
}, {
  clickedMeetingsLink: _clickedMeetingsLink.clickedMeetingsLink
})(_MeetingsLinkButton2.default);
module.exports = exports['default'];